import { NavLink, Outlet } from 'react-router-dom';
import AppHeader from '../../components/layout/AppHeader.jsx';

/**
 * BOS+ Phase 6 — Advanced Time Tracking shell. Sidebar nav + <Outlet/>, reusing
 * the `hr-shell` layout/CSS (mirrors LearningShell). Additive time layer.
 */

const NAV = [
  { to: '/time/timesheets', label: 'Timesheets', testid: 'time-nav-timesheets' },
  { to: '/time/schedules', label: 'Schedules', testid: 'time-nav-schedules' },
];

export default function TimeShell() {
  return (
    <div className="hr-shell" data-testid="time-shell">
      <AppHeader />
      <div className="hr-body">
        <aside className="hr-side">
          <div className="hr-side-title">Time Tracking</div>
          <ul>
            {NAV.map((n) => (
              <li key={n.to}>
                <NavLink to={n.to} data-testid={n.testid} className={({ isActive }) => (isActive ? 'active' : '')}>
                  {n.label}
                </NavLink>
              </li>
            ))}
          </ul>
        </aside>
        <main className="hr-main">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
